<template>
  <div id="app">
    <header>
        <nav class="navbar app-header">
          <div class="navbar-brand">
            <a href="/">
              <img class="logo" src="/static/img/icons/logo-white.svg">
            </a>
          </div>
          <div class="switch-lang align-content-end">
            <a href="#" v-on:click.prevent="switchLanguage()" class="app-lang">
              {{ $t("cmn.switch-lang") }}
            </a>
            <a class="app-info-link"href="#" v-on:click="showModal()"><i class="fa fa-info-circle"></i></a>
            <b-modal id="app-info" class="app-info" ref="appInfo" hide-footer>
              <p class="app-info-txt">{{ $t('cmn.app-info') }}</p>
              <p class="app-intro-txt">{{ $t('cmn.intro-info') }}<br><a class="app-intro-link" href="https://yutamatsumoto.com" target="_blank">{{ $t('item.to-blog') }}</a></p>
              <p>App Version: {{ this.$version }}</p>
              <ul class="list-group">
                <li class="list-group-item">
                  {{ $t('cmn.release-info1') }}
                </li>
                <li class="list-group-item">
                  {{ $t('cmn.release-info2') }}
                </li>
              </ul>
              <p>{{ $t('cmn.ext-info') }}</p>
              <b-btn class="mt-3" variant="outline-danger" block @click="hideModal">{{ $t('item.close') }}</b-btn>
            </b-modal>
          </div>
        </nav>
    </header>
    <main>
      <router-view></router-view>
    <div v-if="adtag"><Adsense data-ad-client="ca-pub-4519316142120062" data-ad-slot="7450659277"></Adsense></div>
    </main>
    
    <footer>
      <div class="footer">
        <div class="copyright">
          &copy;<a href="https://twitter.com/matatabi3" target="_blank">{{ $t('cmn.author') }}</a>
        </div>
        <div class="footer-ext">
          <div class="icon-by">Icons made by <a href="http://www.freepik.com" title="Freepik">Freepik</a> from <a href="https://www.flaticon.com/" title="Flaticon">www.flaticon.com</a> is licensed by <a href="http://creativecommons.org/licenses/by/3.0/" title="Creative Commons BY 3.0" target="_blank">CC 3.0 BY</a></div>
          <div class="icon-by"><router-link to="privacy-policy" class="link">Privacy Policy</router-link></div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  data () {
    return {
      adtag: false
    }
  },
  mounted () {
    if (process.env.NODE_ENV === 'production') {
      this.adtag = true
    }
    if (localStorage.getItem('version') === null || localStorage.getItem('version') < this.$version) {
      localStorage.setItem('version', this.$version)
      this.showModal()
    }
  },
  methods: {
    switchLanguage: function () {
      if (this.$i18n.locale === 'ja') {
        this.$i18n.locale = 'en'
      } else {
        this.$i18n.locale = 'ja'
      }
    },
    showModal () {
      this.$refs.appInfo.show()
    },
    hideModal () {
      this.$refs.appInfo.hide()
    }
  }
}
</script>

<style src="./assets/css/my.css">
</style>


// WEBPACK FOOTER //
// src/App.vue